import styled from 'styled-components';
import { getBaseTheme } from '@Themes';

export const AccordionContainer = styled.div(
    {
        backgroundColor: getBaseTheme().colors.area.default.backgroundColor,

        '&:hover': {
            cursor: 'pointer',
            backgroundColor: getBaseTheme().colors.area.hover.backgroundColor
        }
    },
    ({ opened }) => {
        if (opened) {
            return {
                paddingBottom: getBaseTheme().spaces.default.xs,
                backgroundColor: `${getBaseTheme().colors.area.active.backgroundColor} !important`
            };
        }
        return undefined;
    }
);

export const AccordionItem = styled.div({
    padding: getBaseTheme().spaces.inset.xs,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
});

export const AccordionTitle = styled.h3({
    margin: 0,
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-all'
});

export const LoadingContainer = styled.span({
    margin: 0,
    marginLeft: 'auto',
    marginRight: getBaseTheme().spaces.default.xs
});

export const IconContainer = styled.div({
    margin: 0
});
